/**
 * KLARÈVE Cart Drawer Enhancements
 * Adds micro-interactions: bubble pop, price flash, item entrance animations
 * Loaded globally via stylesheets.liquid
 */
(function () {
  'use strict';

  /* ── Cart Bubble Pop Animation ── */
  function animateCartBubble() {
    var bubbles = document.querySelectorAll('.cart-bubble');
    bubbles.forEach(function (b) {
      b.classList.remove('kc-just-added');
      void b.offsetWidth; // force reflow
      b.classList.add('kc-just-added');
    });
  }

  /* ── Price Flash on Update ── */
  function flashTotalPrice() {
    var totals = document.querySelectorAll('.cart-totals__total-value');
    totals.forEach(function (el) {
      el.classList.remove('kc-updated');
      void el.offsetWidth;
      el.classList.add('kc-updated');
    });
  }

  /* ── Listen for Shopify cart updates ── */
  // Shopify's Section Rendering API dispatches these events
  document.addEventListener('cart:change', function () {
    animateCartBubble();
    flashTotalPrice();
  });

  // Also listen for the theme's custom events
  document.addEventListener('on:cart:add', function () {
    animateCartBubble();
  });

  document.addEventListener('on:cart:update', function () {
    flashTotalPrice();
  });

  /* ── Observe cart drawer for item entrance animations ── */
  var drawerObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && node.classList && node.classList.contains('cart-items__table-row')) {
          node.style.animation = 'kc-slide-in 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
        }
      });
    });
  });

  // Start observing when drawer opens
  function observeDrawer() {
    var drawerItems = document.querySelector('.cart-drawer__items');
    if (drawerItems) {
      drawerObserver.observe(drawerItems, { childList: true, subtree: true });
    }
  }

  // Re-observe on drawer open
  document.addEventListener('on:cart-drawer:open', observeDrawer);

  // Initial observation attempt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeDrawer);
  } else {
    observeDrawer();
  }

  /* ── Smooth remove animation ── */
  document.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('.cart-items__remove');
    if (!removeBtn) return;

    var row = removeBtn.closest('.cart-items__table-row');
    if (row) {
      row.classList.add('removing');
      // Let the animation play before the actual removal
    }
  }, true);

})();
